import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import OffersAmount from 'src/components/OffersAmount';
import 'src/components/JobAlert.scss';

import Bullhorn from '@mdi/svg/svg/bullhorn.svg';

const JobAlert = ({ name, offers, criterias, onJobAlertClick }) => {
  const parametersCriterias = Object.entries(criterias)
    .map((criteria) => criteria.join('='))
    .join('&');
  const jobOffersURL = useSelector((state) => state.configReducer.jobOffersURL);

  return (
    <a
      data-test="anchor-jobAlert"
      href={[jobOffersURL, parametersCriterias].join('?')}
      styleName="job-alert"
      title="Zobacz wyniki wyszukiwania"
      onClick={onJobAlertClick}
    >
      <div styleName="badge">
        {offers !== null && <OffersAmount amount={offers} />}
        <Bullhorn styleName="badge__icon" viewBox="0 0 24 24" />
      </div>

      <h5 styleName="job-alert__name">{name}</h5>
    </a>
  );
};

JobAlert.defaultProps = {
  onJobAlertClick: () => {},
};

JobAlert.propTypes = {
  criterias: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
  name: PropTypes.string.isRequired,
  offers: PropTypes.number,
  onJobAlertClick: PropTypes.func,
};

JobAlert.defaultProps = {
  offers: null,
};

export default JobAlert;
